module.exports = __webpack_public_path__ + "img/chr_ts_90_26.f4187fa2.png";